import { SwitchButtonActive, SwitchButtonNotActive } from '.'

export const renderSwitchItemByActive = (position: number, active: number) => {
    if (position === active) {
        return SwitchButtonActive
    }
    return SwitchButtonNotActive
}